import '@fontsource/montserrat/400.css'
import '@fontsource/montserrat/500.css'
import '@fontsource/montserrat/600.css'

import 'antd/dist/reset.css'
import './src/assets/style/reset.scss'
import './src/assets/style/variables-css.scss'

import './src/assets/style/common.scss'
import './src/assets/style/global.scss'

// NOTE: the global ApolloProvider was removed from here. @apollo/client (~360KB) is now created
// lazily inside the search-results chunk (src/components/Search/SearchResultsProvider.js) so it
// only loads when a visitor actually runs a search — not on every page load. Search was the only
// consumer of Apollo.

// GetResidency's GTM (GTM-WF3D8RH) + Meta Pixel (646394819977004) were cloned in here.
// Removed for Silveroffice: they belong to GR and fire on the wrong domain — the pixel throws
// "unavailable due to traffic permission settings" console errors and aborted requests, and the
// GTM container isn't Silveroffice's. Add Silveroffice's own analytics IDs here if/when set up.
export const onRouteUpdate = () => {
    if (typeof window !== 'undefined') {
        _fixHead()
        setTimeout(_fixHead, 0)
        setTimeout(_fixSlick, 300)
    }
}


// Gatsby Head API + React 19 render SeoHead's <title>/<meta>/<link> in the SVG namespace.
// Consequences: (1) document.title (getter) only reflects an HTML-namespaced <title>, so it
// reads empty → fails the axe/Lighthouse "document-title" audit; (2) SVG-namespaced <meta>
// aren't HTMLMetaElements (no .content/.name IDL), which crashes Lighthouse/PSI's MetaElements
// gatherer → every dependent SEO + Best-Practices audit errors and both categories score 0.
// The tags are correct in the static HTML (crawlers see them); this recreates any mis-namespaced
// metadata node as a proper HTML element so the hydrated DOM PSI evaluates is correct too.
const HTML_NS = 'http://www.w3.org/1999/xhtml'
const _fixHead = () => {
    if (typeof document === 'undefined') return
    document.head.querySelectorAll('title, meta, link').forEach(el => {
        if (el.namespaceURI === HTML_NS) return
        const html = document.createElement(el.localName) // HTML namespace
        for (const a of el.attributes) html.setAttribute(a.name, a.value)
        if (el.localName === 'title') html.textContent = el.textContent
        el.replaceWith(html)
    })
    const t = document.head.querySelector('title')
    if (t && t.textContent && document.title !== t.textContent) document.title = t.textContent
}


// A11y: react-slick marks off-screen/cloned slides aria-hidden but leaves their
// links focusable. Apply `inert` to hidden slides so they leave the tab/a11y tree.
const _fixSlick = () => {
    if (typeof document === 'undefined') return
    document.querySelectorAll('.slick-slide').forEach(sl => {
        if (sl.getAttribute('aria-hidden') === 'true') sl.setAttribute('inert', '')
        else sl.removeAttribute('inert')
    })
}
export const onInitialClientRender = () => {
    _fixHead()
    setTimeout(_fixHead, 0)
    if (typeof window === 'undefined' || typeof MutationObserver === 'undefined') return
    // The Head API re-renders the (mis-namespaced) <title> after the initial commit, resetting
    // document.title. Watch <head> and re-assert the HTML title on every title mutation.
    const headMo = new MutationObserver(_fixHead)
    headMo.observe(document.head, { childList: true, subtree: true, characterData: true })
    _fixSlick()
    const mo = new MutationObserver(_fixSlick)
    mo.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['aria-hidden'] })
}
